import { render, staticRenderFns } from "./CustomerShowTreatment.vue?vue&type=template&id=5249ca0e&scoped=true"
import script from "./CustomerShowTreatment.vue?vue&type=script&lang=js"
export * from "./CustomerShowTreatment.vue?vue&type=script&lang=js"
import style0 from "./CustomerShowTreatment.vue?vue&type=style&index=0&id=5249ca0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5249ca0e",
  null
  
)

export default component.exports